<ng-container *ngIf="modifiers$ | async"></ng-container>
<ng-container *ngIf="data$ | async"></ng-container>

<div mat-dialog-title class="flex flex-row space-x-4 justify-between items-center">
  <div i18n>База материалов</div>
  <button mat-icon-button [mat-dialog-close]="[]">
    <mat-icon>close</mat-icon>
  </button>
</div>

<!-- MENU -->
<div class="p-4 flex flex-row space-x-4 justify-between items-center">
  <div class="flex flex-row space-x-2 justify-between items-center flex-1">
    <mat-form-field appearance="outline" class="dense-input flex-1" floatLabel="never">
      <input matInput ngModel #filter (ngModelChange)="find$.next($event)" placeholder="Поиск" i18n-placeholder />
      <div matSuffix>
        <button mat-icon-button (click)="find$.next(filter.value)">
          <mat-icon class="secondary-text">search</mat-icon>
        </button>
      </div>
    </mat-form-field>
  </div>
</div>
<!-- MENU END -->

<mat-divider> </mat-divider>

<mat-dialog-content class="p-0 pb-0 m-0 ps">
  <as-split direction="horizontal" [unit]="'pixel'">
    <as-split-area [size]="320">
      <csl-group-matrial-tree
        cslPerfectScrollbar
        class="ps flex-1"
        [groupMaterials]="groups"
        [focusedGroupId]="focusedGroupId"
        (selectedGroupChange)="onGroupSelect($event)">
      </csl-group-matrial-tree>
    </as-split-area>

    <as-split-area>
      <div cslPerfectScrollbar class="flex flex-col items-stretch">
        <mat-table #table [dataSource]="dataSource" class="material-list-table">
          <!-- Select Column -->
          <ng-container matColumnDef="select">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let item">
              <mat-checkbox
                [ngModel]="isSelected(item)"
                (change)="toggleSelection(item)"
                [disabled]="isExcludeExists(item)"></mat-checkbox>
            </mat-cell>
          </ng-container>

          <!-- Material Name Column -->
          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef i18n>Наименование</mat-header-cell>
            <mat-cell *matCellDef="let item">
              <span
                #matName
                [matTooltip]="item.name"
                [matTooltipDisabled]="!showFullNameTooltip(matName)"
                class="text-truncate h6 p-1"
                >{{ item.name }}</span
              >
            </mat-cell>
          </ng-container>

          <!-- Material Article Column -->
          <ng-container matColumnDef="article">
            <mat-header-cell *matHeaderCellDef i18n>Артикул</mat-header-cell>
            <mat-cell *matCellDef="let item">
              <span
                #matArticle
                [matTooltip]="item.name"
                [matTooltipDisabled]="!showFullNameTooltip(matArticle)"
                class="text-truncate"
                >{{ item.article }}</span
              >
            </mat-cell>
          </ng-container>

          <!-- Material Price Column -->
          <ng-container matColumnDef="price">
            <mat-header-cell *matHeaderCellDef i18n>Цена</mat-header-cell>
            <mat-cell *matCellDef="let item">
              {{ item.price | formatNumber : 2 | formatCurrency }}/{{ item.measureName }}
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row
            class="material-list-row"
            *matRowDef="let row; columns: displayedColumns"
            [ngClass]="{ selected: isSelected(row), 'disabled-row': isExcludeExists(row) }"></mat-row>
        </mat-table>
        <!-- </div> -->

        <div class="flex flex-row justify-center">
          <button
            class="m-32"
            color="accent"
            *ngIf="hasMore && !loading"
            (click)="loadMore$.next([loadMore$.value[0] + 1, loadMore$.value[1]])"
            mat-stroked-button
            i18n
            >Загрузить еще</button
          >
          <mat-spinner *ngIf="loading" class="m-32" [diameter]="16"> </mat-spinner>
        </div>
      </div>
    </as-split-area>
  </as-split>
</mat-dialog-content>

<div mat-dialog-actions>
  <button mat-raised-button class="mat-accent" (click)="saveAndClose()" i18n>ОК</button>
  <button mat-button (click)="dialogRef.close([])" i18n>ОТМЕНА</button>
</div>
